export const ORDER_TYPE = {
  PURCHASE: 1,
  SALE: 2,
  INTERNAL: 3,
};